import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent } from '@sb/library/base';
import { CalendarBookingDisplayItem, LanguageDisplayItem, TagDisplayItem, TeacherNameDisplayItem, WebsiteRenderContextTeacherNameDisplayItem } from '@sb/library/data-models';
import { PreFetchedSlots } from '../signup-form.definitions';

@Component({
    selector: 'lib-signup-form-design-block-teachers',
    templateUrl: './signup-form-design-block-teachers.component.html',
    styleUrl: './signup-form-design-block-teachers.component.scss'
})
export class SignupFormDesignBlockTeachersComponent extends BaseViewComponent {

    @Output() previousClicked: EventEmitter<void> = new EventEmitter();

    private _teachers: WebsiteRenderContextTeacherNameDisplayItem[] = [];

    @Input()
    set teachers(teachers: WebsiteRenderContextTeacherNameDisplayItem[]) {
        this._teachers = teachers;
        this._visibleTeachers = teachers.slice(0, this._visibleItemsCount);
    }
    @Input() bookingSlots: CalendarBookingDisplayItem[] = [];
    @Input() subjectTag?: TagDisplayItem;
    @Input() category?: string;
    @Input() existingEvents!: boolean;
    @Input() schoolID!: string;

    @Input() isViewOnly: boolean = false;
    @Output() signupClicked: EventEmitter<PreFetchedSlots> = new EventEmitter();

    readonly AllTeachersID: string = " AllTeachers";
    readonly maxLabelsPerRow: number = this.isMobile ? 3 : 5;

    private _itemSelected: string | null = null;
    private _clicked: boolean = false;
    private _visibleItemsCount: number = 4;
    private _availableBookingSlots: CalendarBookingDisplayItem[] = [];
    private _visibleTeachers: WebsiteRenderContextTeacherNameDisplayItem[] = [];

    ItemSelected(teacherID: string): void {
        this._itemSelected = teacherID;
        this.Signup();
    }

    Signup(): void {
        this._availableBookingSlots = [...this.bookingSlots];

        this.signupClicked.emit({
            SubjectTag: !this.existingEvents ? this.subjectTag! : undefined,
            BookingSlots: this._availableBookingSlots,
            TeacherID: (this._itemSelected == this.AllTeachersID) ? undefined : this._itemSelected!,
            Category: this.existingEvents ? this.category! : undefined
        });
        this._clicked = true;
    }

    Reset(): void {
        this._clicked = false;
        this._itemSelected = null;
        this._visibleItemsCount = 4;
    }

    ShowMoreItems(): void {
        this._visibleItemsCount = Math.min(this._visibleItemsCount + 6, this._teachers.length);
        this._visibleTeachers = this._teachers.slice(0, this._visibleItemsCount);
    }

    PreviousClicked(): void {
        this.previousClicked.emit();
    }

    GetProfileHeadshotURL(item: WebsiteRenderContextTeacherNameDisplayItem): string {
        // Bypassing security to use SchoolID for the ProfilePictureViewer.ashx
        return item.ProfileHeadshotURL + `&SchoolID=${this.schoolID!}`;
    }

    GetMoreLanguagesTooltipText(languages: LanguageDisplayItem[]): string {
        return languages.slice(this.maxLabelsPerRow - 1).map(language => language.NativeName).join(', ');
    }

    get itemSelected(): string | null {
        return this._itemSelected;
    }

    get clicked(): boolean {
        return this._clicked;
    }

    get visibleItemsCount(): number {
        return this._visibleItemsCount;
    }

    get visibleTeachers(): WebsiteRenderContextTeacherNameDisplayItem[] {
        return this._visibleTeachers;
    }

    get totalTeachersCount(): number {
        return this._teachers.length;
    }

}
